import { atom, getDefaultStore } from 'jotai'

import { getItem } from '@/utils/storage'

export const tokenAtom = atom<string | undefined>(getItem<string>('token'))

export const removeTokenAtom = () => {
  const store = getDefaultStore()
  store.set(tokenAtom, undefined)
}
